export const shortTitleList = ['LDI', 'CDT', 'CDS'];
